import { render } from "./GenerateApprovalNoPODialog.vue?vue&type=template&id=0bb87f67&scoped=true"
import script from "./GenerateApprovalNoPODialog.vue?vue&type=script&lang=ts"
export * from "./GenerateApprovalNoPODialog.vue?vue&type=script&lang=ts"

import "./GenerateApprovalNoPODialog.vue?vue&type=style&index=0&id=0bb87f67&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0bb87f67"

export default script